import { NotificationCard } from '../../components/Card';
import { Flex, Center, Button } from '@chakra-ui/react';
import { useHistory } from 'react-router-dom';
import { LayersThree01 } from '@kula-ai/icons-core';
import { NotificationTime } from '../../components/Time';
import {
  RequisitionDetailsSection,
  RequisitionDetailsList,
  useRequisitionData,
} from './components';
import { KText } from '@/ui-library/components';

const RequisitionFilled = ({ notification = {}, onClose = () => {} }) => {
  const {
    requisition_id,
    requisition_code,
    requisition_ids,
    requisition_codes,
    role_name,
    filled_by_name,
    candidate_name,
    offer_salary,
    buildRequisitionDetails,
    requester_name,
  } = useRequisitionData(notification);
  const history = useHistory();

  const displayCode = requisition_codes
    ? Array.isArray(requisition_codes)
      ? requisition_codes.join(', ')
      : requisition_codes
    : requisition_code;

  const fillDetailsData = [
    { label: 'Filled by', value: filled_by_name },
    { label: 'Candidate', value: candidate_name },
    { label: 'Salary', value: offer_salary },
  ];

  const requisitionDetailsData = buildRequisitionDetails([
    { label: 'Created by', value: requester_name },
  ]);

  const handleViewRequisition = () => {
    if (requisition_id || requisition_ids?.[0]) {
      history.push(
        `/requisitions?view=${requisition_id || requisition_ids?.[0]}`
      );
      onClose();
    }
  };

  return (
    <Flex alignItems="baseline" gap="6px">
      <Center minW="34px" h="34px" borderRadius="sm" bg="pastel-2-light">
        <LayersThree01
          size={16}
          color="var(--kula-colors-pastel-2-dark)"
          className="kula-icon"
        />
      </Center>
      <Flex flexDir="column" ml="16px" gap="8px" alignSelf="start" flex="1">
        <KText>
          Requisition{' '}
          <KText as="span" fontWeight="semiBold">
            {displayCode}
          </KText>{' '}
          for{' '}
          <KText as="span" fontWeight="semiBold">
            {role_name}
          </KText>{' '}
          has been filled
        </KText>

        <RequisitionDetailsSection title="Details">
          <RequisitionDetailsList data={fillDetailsData} />
        </RequisitionDetailsSection>

        <RequisitionDetailsSection title="Requisition details">
          <RequisitionDetailsList data={requisitionDetailsData} />
        </RequisitionDetailsSection>

        <Button
          variant="primary"
          onClick={handleViewRequisition}
          size="sm"
          w="fit-content"
        >
          View requisition
        </Button>

        <NotificationTime notification={notification} />
      </Flex>
    </Flex>
  );
};

export const RequisitionFilledNotification = ({
  notification = {},
  onClose = () => {},
}) => {
  return (
    <NotificationCard notification={notification}>
      <RequisitionFilled notification={notification} onClose={onClose} />
    </NotificationCard>
  );
};
